import { useTranslation } from 'react-i18next';
import { uiLanguageOf, type UiLanguage } from '@/i18n';
import { getLocaleFormatter, type LocaleFormatter } from '@/lib/locale-format';

/**
 * S4-35 (I18N-PANEL): текущий язык интерфейса (код из каталога UI-языков).
 *
 * @ensures Реактивен к смене языка: `useTranslation` подписывает компонент
 *   на `languageChanged`.
 */
export function useUiLanguage(): UiLanguage {
  const { i18n } = useTranslation();
  return uiLanguageOf(i18n);
}

/**
 * S4-35 (I18N-PANEL, I4): форматтер дат/чисел/сумм для ТЕКУЩЕГО языка UI.
 *
 * @contract Реактивен к смене языка: следующий рендер получает форматтер
 *   нового языка; компоненты не маппят язык в Intl-локаль сами.
 * @ensures Возвращает стабильный (кэшированный на язык) объект — его можно
 *   класть в зависимости `useMemo`/`useCallback`.
 */
export function useLocaleFormat(): LocaleFormatter {
  return getLocaleFormatter(useUiLanguage());
}
